/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A literal value carried by a JSON Schema keyword.
 */
export type ToolSchemaStaticValue = {
  /**
   * The JSON Schema keyword containing the value
   */
  keyword: string;
  /**
   * JSON Pointer to the schema object containing the keyword
   */
  schemaPath: string;
  /**
   * JSON-encoded literal value, preserving null and number precision
   */
  valueJson: string;
};

/** @internal */
export const ToolSchemaStaticValue$inboundSchema: z.ZodMiniType<
  ToolSchemaStaticValue,
  unknown
> = z.pipe(
  z.object({
    keyword: z.string(),
    schema_path: z.string(),
    value_json: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "schema_path": "schemaPath",
      "value_json": "valueJson",
    });
  }),
);

export function toolSchemaStaticValueFromJSON(
  jsonString: string,
): SafeParseResult<ToolSchemaStaticValue, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolSchemaStaticValue$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolSchemaStaticValue' from JSON`,
  );
}
